import { useState, useEffect, useContext } from "react";
import { Checkbox, Row, Col, Result, Button } from "antd";
import { useStaffActions } from "@iso/actions/staffSetting.actions";
import { useParams } from "react-router-dom";
import { message } from "../../../node_modules/antd/lib/index";
import Page from "component/Page/index";
import Loading from "../Loading/index";
import styled from "styled-components";
import { useGroupRoleActions } from "@iso/actions/groupRole.actions";
import { UserContext } from "../../context/UserContext";
const CustomStyle = styled.div`
   .ant-checkbox-wrapper {
      margin-bottom: 8px;
   }
`;

const GroupRoleStaff = () => {
   const { id } = useParams();
   const [isLoading, setIsLoading] = useState(true);
   const [checkedListDict, setCheckedListDict] = useState({});
   const [dataDetail, setDataDetail] = useState();
   const [roles, setRoles] = useState([]);
   const staffActions = useStaffActions();
   const roleActions = useGroupRoleActions();
   const {
      user,
      reloadStores,
      isLoading: isUserLoading,
   } = useContext(UserContext);

   const getData = async () => {
      setIsLoading(true);
      try {
         const resGet = await staffActions.getStaffById(id);
         console.log("resGet:", resGet);
         setDataDetail(resGet);
      } catch (error) {
         console.log(error);
      } finally {
         setIsLoading(false);
      }
   };

   const getRoles = async () => {
      setIsLoading(true);
      try {
         const resGet = await roleActions.getGroupRoleList();
         console.log("resGet:", resGet);
         setRoles(resGet?.items || []);
      } catch (error) {
         console.log(error);
      } finally {
         setIsLoading(false);
      }
   };

   const getRolesByUserId = async () => {
      setIsLoading(true);
      try {
         const resGet = await roleActions.getRolesByUserId(id);
         if (resGet?.items?.length) {
            let _checkedListDict = {};
            resGet.items.forEach((item) => {
               _checkedListDict[item.id] = true;
            });
            setCheckedListDict(_checkedListDict);
         }
         console.log("test:", resGet);
      } catch (error) {
         console.log(error);
      } finally {
         setIsLoading(false);
      }
   };

   useEffect(() => {
      getData();
      getRoles();
      getRolesByUserId();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, []);

   const handleSelectRole = async (userId, roleId, checked) => {
      try {
         const role = roles.find((m) => m.id === roleId && checked);
         if (role) {
            const rolesToUpdate = roles
               .filter((r) => checkedListDict[r.id])
               .map((r) => r.name);
            await staffActions.updateStaffRole(userId, {
               roleNames: [...rolesToUpdate, role.name],
            });
            message.success("Assign role success!", [0.5]);
         } else {
            const rolesToUpdate = roles
               .filter((r) => checkedListDict[r.id] && r.id !== roleId)
               .map((r) => r.name);
            await staffActions.updateStaffRole(userId, {
               roleNames: rolesToUpdate,
            });
            message.success("Remove role success!", [0.5]);
         }
         let _checkedListDict = { ...checkedListDict };
         _checkedListDict[roleId] = checked;
         setCheckedListDict(_checkedListDict);
      } catch (error) {
         console.log(error);
      } finally {
      }
   };

   return (
      <>
         {isLoading || isUserLoading || !user?.permissions ? (
            <Loading />
         ) : user &&
           user.permissions?.["BackOfficeMenu.IAM.Roles.AssignRole"] ? (
            <Page title="Group Role Staff">
               <div className="assign-store-wrapper">
                  <div className="px-6 py-8 mb-12 bg-white-0 rounded-sm shadow-sm">
                     <Row>
                        <Col span={8}>
                           <h3 className="mb-0">{dataDetail?.name || "-"}</h3>
                        </Col>
                        <Col span={8}>
                           <h3 className="mb-0">{dataDetail?.email || "-"}</h3>
                        </Col>
                        <Col span={8}>
                           <h3 className="mb-0">
                              {dataDetail?.phoneNumber || "-"}
                           </h3>
                        </Col>
                     </Row>
                  </div>
                  <hr />
                  <h2 className="my-7">Group role list</h2>
                  <div className="px-6 py-8 rounded-sm shadow-sm bg-white-0">
                     <CustomStyle>
                        <Checkbox.Group
                           style={{ width: "100%" }}
                           value={Object.entries(checkedListDict)
                              .filter(([_, value]) => value)
                              .map(([key]) => key)}
                        >
                           <Row>
                              {roles.length > 0
                                 ? roles.map((item) => (
                                      <Checkbox
                                         key={item.id}
                                         value={item.id}
                                         checked={
                                            checkedListDict[item.id] === true
                                         }
                                         onClick={(e) =>
                                            handleSelectRole(
                                               id,
                                               e.target?.value,
                                               !checkedListDict[item.id]
                                            )
                                         }
                                         style={{ marginBottom: 0 }}
                                      >
                                         <h4 className="mb-0">{item?.name}</h4>
                                      </Checkbox>
                                   ))
                                 : ""}
                           </Row>
                        </Checkbox.Group>
                     </CustomStyle>
                  </div>
               </div>
            </Page>
         ) : (
            <Result
               status="403"
               title="403"
               subTitle="Sorry, you don't have allowance to access this page"
               extra={<Button type="primary">Back Home</Button>}
            />
         )}
      </>
   );
};

export default GroupRoleStaff;
